




























import {Component, Watch, Vue, Prop} from "vue-property-decorator";
import RouteTranslations from "@/locales/routerTranslations";
import {UtilitiesFunctions} from "@/helpers";
@Component
export default class BannerHomeCard extends Vue {
  @Prop({ default: "" }) private title!: string;
  @Prop({ default: "" }) private description!: string;

  @Watch("$i18n.locale", { immediate: true, deep: true })
  localeChanged() { }

  mounted() {
  }
  handleClick() {
    this.$router.push({ path: "/esperienze", query: { expType: 'smart' } });
  }
}
